/**
 * Pure routing rule: should this authenticated user be redirected into the
 * onboarding wizard?
 *
 * Regression context (2026-07-08): nothing ever routed a NEW user into
 * /onboarding — every signup (email and OAuth alike) landed on /dashboard
 * where the wizard's only entry was a dismissable banner. 3/3 signups on
 * Jul 7 produced zero wizard events. This is a HARD redirect, so the wizard
 * must always have a way out: the later steps are skippable, and the résumé
 * import step (mandatory since 2026-10-14, no Skip button) carries the "I don't
 * have a resume file yet" link, which completes onboarding without a résumé and
 * lands on the résumé builder. That link is the escape for people with no file,
 * a parse failure or an exhausted daily parse quota; remove or hide it and this
 * guard traps them out of the dashboard, the CV builder and billing.
 *
 * Exclusions:
 * - /onboarding itself (would loop)
 * - /auth/* (verify-email and OAuth callback render under AuthGuard mid-flow)
 */
export const needsOnboardingRedirect = (
  user: { onboardingCompleted?: boolean } | null | undefined,
  pathname: string,
): boolean => {
  if (user?.onboardingCompleted !== false) return false;
  if (pathname.startsWith("/onboarding")) return false;
  if (pathname.startsWith("/auth")) return false;
  return true;
};
